/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectDescriptionWithOrigin
 */
export interface ProjectDescriptionWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof ProjectDescriptionWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof ProjectDescriptionWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the ProjectDescriptionWithOrigin interface.
 */
export function instanceOfProjectDescriptionWithOrigin(value: object): value is ProjectDescriptionWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function ProjectDescriptionWithOriginFromJSON(json: any): ProjectDescriptionWithOrigin {
    return ProjectDescriptionWithOriginFromJSONTyped(json, false);
}

export function ProjectDescriptionWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectDescriptionWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function ProjectDescriptionWithOriginToJSON(value?: ProjectDescriptionWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

